import styled from "styled-components";

export const FooterStyled = styled.div`
  .privacypolicy{
    margin:0px 30px;
    padding:0px;
  }
  .privacypolicy h1, .privacypolicy h2 {
    font-size: 20px;
  }
  .footer-main-section{
  box-shadow: 0px -1px 0px 0px #00000021;
  background: #F9F9F9;
  }
  .footer-top-section{
    margin:0px 30px;
    padding:30px 0px;
    border-bottom: 1px solid #00000021;
    font-family: Poppins;
    font-size: 17px;
    font-weight: 500;
    line-height: 34px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 40px;
    }
    .termsandconditions{
      display: flex;
      gap: 20px;
    }
    .social-media{
      display: flex;
      justify-content: center;
      gap: 20px;
      img{
        width:20px;
        height: 20px;
        cursor: pointer;
      }
    }
  .footer-bottom-section{
    text-align: center;
    padding: 24px;
    font-family: Poppins;
    font-size: 17px;
    font-weight: 500;
    line-height: 34px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
   }
   .privacypolicy{
    cursor: pointer;
   }

  // Mobile Responsiveness 

   @media screen and (max-width: 767px) {
    .privacypolicy {
      margin: 0px 0px;
    }
  .footer-top-section{
    grid-template-columns: repeat(1, 1fr)!important;
    margin:0px 16px;
    padding:16px 0px;
    font-size: 16px;
    line-height: 45px;
  }
  .footer-top-section .termsandconditions{
    display: block;
  }
   .footer-bottom-section{
    padding: 16px;
    font-size: 14px;
    }
    .social-media{
    display: flex;
    justify-content: left;
    gap: 15px;
    }
}
`;
